import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c116ed3")

_pushScopeId("data-v-2c116ed3")
const _hoisted_1 = { class: "main__section" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 진료비 결제 ")
const _hoisted_3 = {
  key: 0,
  class: "request-view view-card"
}
const _hoisted_4 = { class: "view-card__header" }
const _hoisted_5 = {
  key: 0,
  class: "view-card__header__mid"
}
const _hoisted_6 = {
  key: 0,
  class: "view-card__header__mid"
}
const _hoisted_7 = { class: "list-item-detail" }
const _hoisted_8 = { class: "-medium" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "-medium" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "label" }, "유형", -1)
const _hoisted_13 = { class: "value" }
const _hoisted_14 = {
  key: 0,
  class: "-medium -pc"
}
const _hoisted_15 = { class: "label -notosans" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = {
  key: 0,
  class: "-medium -mobile scheduled-date"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "label" }, "예약일시", -1)
const _hoisted_19 = { class: "value -notosans" }
const _hoisted_20 = { class: "bill__info" }
const _hoisted_21 = { class: "bill__info__price" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h4", { class: "-bold" }, "결제 정보", -1)
const _hoisted_23 = { class: "label" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "label" }, "총 결제금액", -1)
const _hoisted_26 = { class: "value -royalBlue" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "bill__info__warning" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 진료예약신청이 "),
    /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "확정되기 전까지 취소시 100% 취소/환불이 가능"),
    /*#__PURE__*/_createTextVNode("하며, "),
    /*#__PURE__*/_createVNode("br", { class: "-pc" }),
    /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "이후 취소하거나 미참석일 경우, 10%의 패널티가 부가"),
    /*#__PURE__*/_createTextVNode(" 되어 90% 취소/환불 됩니다. ")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 진료예약신청 전까지 "),
    /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "'날짜 및 시간'"),
    /*#__PURE__*/_createTextVNode(" 변경 가능합니다. ")
  ])
], -1)
const _hoisted_29 = { class: "bill__info__method" }
const _hoisted_30 = /*#__PURE__*/_createVNode("h4", { class: "-bold" }, "결제수단 선택", -1)
const _hoisted_31 = { class: "method__select" }
const _hoisted_32 = {
  key: 0,
  class: "card"
}
const _hoisted_33 = {
  key: 0,
  class: "cash"
}
const _hoisted_34 = {
  key: 0,
  class: "payment__agree"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 상기 결제 내역을 확인, 결제 진행에 동의")
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "(필수)", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 취소/환불 수수료 및 기한을 확인 하였으며 동의 ")
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "(필수)", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 개인정보 제 3자 정보 제공 동의 ")
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "(필수)", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("small", null, " 예약서비스 및 커뮤니케이션을 위해 개인정보를 제공받는 대상 : 헤셀의원", -1)
const _hoisted_42 = { class: "request__footer" }
const _hoisted_43 = { class: "footer__bill" }
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { class: "label -medium" }, "총 결제금액", -1)
const _hoisted_45 = { class: "value -bold" }
const _hoisted_46 = { class: "request-form__footer--actions" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("취소")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("결제하기")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DoctorItem = _resolveComponent("DoctorItem")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Button = _resolveComponent("Button")
  const _component_PageFrame = _resolveComponent("PageFrame")
  const _component_Form = _resolveComponent("Form")
  const _directive_simpleHeader = _resolveDirective("simpleHeader")

  return _withDirectives((_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      (!_ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_Form, {
            key: 0,
            class: "checkout__request__form",
            action: "",
            method: "",
            onSubmit: _ctx.pay
          }, {
            default: _withId(() => [
              _createVNode(_component_PageFrame, { class: "form__content" }, {
                title: _withId(() => [
                  _hoisted_2
                ]),
                content: _withId(() => [
                  (!_ctx.state.isLoading)
                    ? (_openBlock(), _createBlock("div", _hoisted_3, [
                        _createVNode("div", _hoisted_4, [
                          (!!_ctx.state.payInfo.DoctorInfo.DoctorKey)
                            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                                (!!_ctx.state.payInfo.DoctorInfo.DoctorKey)
                                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                                      _createVNode(_component_DoctorItem, {
                                        doctor: _ctx.state.payInfo.DoctorInfo,
                                        isDefaultDetail: false
                                      }, {
                                        detail: _withId(() => [
                                          _createVNode("div", _hoisted_7, [
                                            _createVNode("ul", null, [
                                              _createVNode("li", _hoisted_8, [
                                                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.state.payInfo.DoctorInfo.DeptName), 1),
                                                _createVNode("span", _hoisted_10, _toDisplayString(_ctx.state.payInfo.DoctorInfo.DoctorName), 1)
                                              ]),
                                              _createVNode("li", _hoisted_11, [
                                                _hoisted_12,
                                                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.requestKind), 1)
                                              ]),
                                              (
                                _ctx.state.payInfo.RequestInfo.RequestKind ===
                                _ctx.RequestKindTypes.OnlineCare
                              )
                                                ? (_openBlock(), _createBlock("li", _hoisted_14, [
                                                    _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t("reserved date/time")), 1),
                                                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.scheduledDate), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["doctor"]),
                                      (
                        _ctx.state.payInfo.RequestInfo.RequestKind ===
                        _ctx.RequestKindTypes.OnlineCare
                      )
                                        ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                            _createVNode("div", null, [
                                              _hoisted_18,
                                              _createVNode("span", _hoisted_19, _toDisplayString(_ctx.scheduledDate), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode("ul", null, [
                        _createVNode("li", null, [
                          _createVNode("span", _hoisted_23, _toDisplayString(_ctx.state.payInfo.PaymentInfo.ProductName), 1),
                          _createVNode("span", _hoisted_24, _toDisplayString(_ctx.PaymentAmount) + " 원", 1)
                        ]),
                        _createVNode("li", null, [
                          _hoisted_25,
                          _createVNode("span", _hoisted_26, _toDisplayString(_ctx.PaymentAmount) + " 원", 1)
                        ])
                      ])
                    ]),
                    _hoisted_27,
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode("div", _hoisted_31, [
                        _createVNode(_component_SelectButton, {
                          modelValue: _ctx.payment.method,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.payment.method = $event)),
                          options: _ctx.paymentOptions,
                          class: "agree",
                          optionLabel: "name",
                          optionValue: "value"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createVNode(_Transition, { name: "card" }, {
                        default: _withId(() => [
                          (_ctx.payment.method === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_32))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, { name: "cash" }, {
                        default: _withId(() => [
                          (_ctx.payment.method === 2)
                            ? (_openBlock(), _createBlock("div", _hoisted_33))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, { name: "agree" }, {
                        default: _withId(() => [
                          (_ctx.payment.method)
                            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                                _createVNode("span", {
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.agreeAllToggle && _ctx.agreeAllToggle(...args))),
                                  checked: _ctx.agreeAll,
                                  class: "-bold"
                                }, "전체 동의하기", 8, ["checked"]),
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _createVNode("span", {
                                      checked: _ctx.agrees.agree1,
                                      onClick: _cache[3] || (_cache[3] = 
                            () => {
                              _ctx.agrees.agree1 = !_ctx.agrees.agree1;
                            }
                          )
                                    }, [
                                      _hoisted_35,
                                      _hoisted_36
                                    ], 8, ["checked"])
                                  ]),
                                  _createVNode("li", null, [
                                    _createVNode("span", {
                                      checked: _ctx.agrees.agree2,
                                      onClick: _cache[4] || (_cache[4] = 
                            () => {
                              _ctx.agrees.agree2 = !_ctx.agrees.agree2;
                            }
                          )
                                    }, [
                                      _hoisted_37,
                                      _hoisted_38
                                    ], 8, ["checked"])
                                  ]),
                                  _createVNode("li", null, [
                                    _createVNode("span", {
                                      checked: _ctx.agrees.agree3,
                                      onClick: _cache[5] || (_cache[5] = 
                            () => {
                              _ctx.agrees.agree3 = !_ctx.agrees.agree3;
                            }
                          )
                                    }, [
                                      _hoisted_39,
                                      _hoisted_40
                                    ], 8, ["checked"])
                                  ])
                                ]),
                                _hoisted_41
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                footer: _withId(() => [
                  _createVNode("div", _hoisted_42, [
                    _createVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode("span", _hoisted_45, _toDisplayString(_ctx.PaymentAmount), 1)
                    ])
                  ])
                ]),
                action: _withId(() => [
                  _createVNode("div", _hoisted_46, [
                    _createVNode(_component_Button, {
                      class: "-button -waikawaGrey",
                      type: "button"
                    }, {
                      default: _withId(() => [
                        _hoisted_47
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      class: "-button -royalBlue",
                      type: "submit",
                      disabled: !_ctx.payment.method || !_ctx.agreeAll
                    }, {
                      default: _withId(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [_directive_simpleHeader]
  ])
})